class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      if(this.dataset.product === shippingProtectionProduct) {
        sessionStorage.setItem('le_ship_protection_opted_out', true);
        sessionStorage.setItem('le_ship_protection_variant', '');
      }
      if(document.getElementById('gwp__user-add-submit-button')) {
        document.getElementById('gwp__user-add-submit-button').addEventListener('click', addUserAddGiftWithPurchase);
        gwpSelectChange();
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    fetch('/cart.js')
    .then((response) => response.json())
    .then((responseText) => {
      let cartItems2 = responseText.items;
      this.updateCartCrossSells(cartItems2);
    });
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    var bundleVariantIds = [...document.querySelectorAll('.bundle-item-components')];
    var bundleProductInCart = [];
    var len = bundleVariantIds.length;
    for (var i = 0; i < len; i++) {
      bundleProductInCart.push({
        bundleVarId: bundleVariantIds[i].attributes.bundleVarId.value,
        bundleVarTotalQuant: bundleVariantIds[i].attributes.bundleVarTotalQuant.value,
        bundleVariantTitle: bundleVariantIds[i].innerText,
      });
    }

    var result1 = [...bundleProductInCart.reduce( (mp, o) => {
      if (!mp.has(o.bundleVarId)) mp.set(o.bundleVarId, { ...o, count: 0 });
      mp.get(o.bundleVarId).count++;
      return mp;
    }, new Map).values()];

    cartGetBundleComponents();
    var result = [...cartItemComponents.reduce( (mp, o) => {
      if (!mp.has(o.id)) mp.set(o.id, { ...o, count: 0 });
      mp.get(o.id).count++;
      return mp;
    }, new Map).values()];

    for(let i = 0; i < bundleProductInCart.length; i++) {
      if(result || result1) {
        var checkIfBundleVarOneInCart = result.find(e => e.id == bundleProductInCart[i].bundleVarId);
        var checkIfBundleVarOneInCart2 = result1.find(e => e.id == bundleProductInCart[i].bundleVarId);
        var checkIfBundleVarOneInCart3 = result1.find(e => e.bundleVarId == bundleProductInCart[i].bundleVarId);
    
        if((checkIfBundleVarOneInCart && checkIfBundleVarOneInCart.count == bundleProductInCart[i].bundleVarTotalQuant) || (checkIfBundleVarOneInCart2 && checkIfBundleVarOneInCart2.count == bundleProductInCart[i].bundleVarTotalQuant) || (checkIfBundleVarOneInCart3 && checkIfBundleVarOneInCart3.count == bundleProductInCart[i].bundleVarTotalQuant)) {
          var bundleErrVariant = document.querySelectorAll(`[bundlevarid="${bundleProductInCart[i].bundleVarId}"]`);
          bundleErrVariant.forEach((element) => {
            var quantityParentElement = element.parentElement.parentElement.querySelector('.cart-quantity');
            quantityParentElement.querySelector('.quantity__input').setAttribute('disabled', 'disabled');
            quantityParentElement.querySelector('.cart-quantity [name="plus"]').setAttribute('disabled', 'disabled');
            quantityParentElement.querySelector('.cart-quantity [name="plus"]').style.color = 'gray';
            quantityParentElement.querySelector('.cart-quantity [name="plus"]').style.cursor = 'not-allowed';
          })
        }
      }
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
      if(document.getElementById('gwp__user-add-submit-button')) {
        document.getElementById('gwp__user-add-submit-button').addEventListener('click', addUserAddGiftWithPurchase);
        gwpSelectChange();
      }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-footer'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        const cartItem = document.querySelectorAll('.cart-item .cart-item__details a');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const cartHeader = document.getElementById('cart-header');
        const cartWarnings = document.getElementById('cart-warnings');
        const giftNote = document.getElementById('gift-note');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartHeader) cartHeader.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartWarnings) cartWarnings.classList.toggle('is-empty', parsedState.item_count === 0);
        if (giftNote) giftNote.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));


        let cartTotalValue = Number(document.querySelector('.totals__subtotal-value').getAttribute('value'));
        if(gwpProduct.gwpToggle) {
          if(gwpProduct.gwpVariation === 'Auto Add' && gwpProduct.gwpProductInformation.available && cartTotalValue >= gwpProduct.gwpGoal) {
            addAutoAddGiftWithPurchase();
          } else if(gwpProduct.gwpVariation === 'Auto Add' && gwpProduct.gwpProductInformation.available && cartTotalValue < gwpProduct.gwpGoal) {
            removeAutoAddGiftWithPurchase();
          } else if(gwpProduct.gwpVariation === 'User Add' && cartTotalValue >= gwpProduct.gwpGoal && cartTotalValue !== 0) {
            checkIfUserAddGiftProductExistsInCart();
            document.getElementById('userAddGiftWithPurchase').addEventListener('submit', addUserAddGiftWithPurchase);
          } else if(gwpProduct.gwpVariation === 'User Add' && (cartTotalValue < gwpProduct.gwpGoal || cartTotalValue == 0)) {
            checkIfUserAddGiftProductExistsInCart();
            removeUserAddGiftWithPurchase();
          }
        }

        if(document.getElementById('pouch__user-add-submit-button')) {
          document.getElementById('pouch__user-add-submit-button').addEventListener('click', addPouchAddon);
          checkIfPouchExistsInCart();
        }

        // if(!sessionStorage.getItem('le_ship_protection_opted_out') || sessionStorage.getItem('le_ship_protection_opted_out') == 'false') {
        //   document.getElementById('cartShippingProtection').checked = true;
        //   determineShippingProtection();
        // }

        if(document.getElementById('gwp__user-add-submit-button')) {
          document.getElementById('gwp__user-add-submit-button').addEventListener('click', addUserAddGiftWithPurchase);
          gwpSelectChange();
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message, parsedState.items);

        window.Klarna.OnsiteMessaging.refresh();

        if (window.location.href.indexOf("/cart") <= -1) {
          /* Progress Bar - Cart Drawer */
          const goalValue = document.querySelector('.cart-alert').getAttribute("metafield-goal-value");
          let cartSubtotalValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value").getAttribute('value');
          let goalRemainingValue = goalValue - cartSubtotalValue;
          goalRemainingValue = Number(goalRemainingValue).toFixed(2);

          if(goalRemainingValue > 0) {
            document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
            document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
            document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue}`;
            document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue);
            document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$8'
          } else {
            document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
            document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
            document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue);
            document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$0'
          }

          let cartDrawerWishlist = document.querySelectorAll('#CartDrawer .quick-add-wishlist');
          if(cartDrawerWishlist) {
            cartDrawerWishlist.forEach(function(item) {
              item.remove();
            });
          }

          let cartDrawerBlackFridaySale = document.querySelectorAll('#CartDrawer .global-discount__savings');
          if(cartDrawerBlackFridaySale) {
            cartDrawerBlackFridaySale.forEach(function(item) {
              item.remove();
            });
          }
          
          const scrollbarVisible = (element) => {
            return element.scrollHeight > element.clientHeight;
          }
          const cartDrawerContainer = document.querySelector('cart-drawer-items')
          if(scrollbarVisible(cartDrawerContainer) === true) {
            document.querySelector('.cart-drawer .drawer__cart-items-wrapper').style.marginRight = '1rem';
            document.querySelector('.cart-drawer .cart-alert').style.marginRight = '1rem';
            document.querySelector('.cart-drawer .slider-button--next').style.marginRight = '1rem';
          }
        }

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message, cartItems) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.updateCartCrossSells(cartItems);
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);

    if(this.currentItemCount > 0) {
      document.querySelector('.collection__hide-on-not-empty').classList.add('hidden');
      document.querySelector('.collection__hide-on-empty').classList.remove('hidden')
    } else if(this.currentItemCount === 0) {
      document.querySelector('.collection__hide-on-not-empty').classList.remove('hidden')
      document.querySelector('.collection__hide-on-empty').classList.add('hidden')
    }
  }

  updateCartCrossSells(cartItems) {
    let cartCrossSellProducts = document.querySelectorAll('.cross-sell__products');

    if (cartItems.filter(e => e.product_type === 'rings').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('ringProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'rings').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('ringProductType') && (!upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('necklaceProductType'))) {
          upsell.classList.add('hidden');
        }
      });
    }
    if (cartItems.filter(e => e.product_type === 'earrings').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'earrings').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }
    if(cartItems.filter(e => e.product_type === 'earrings').length <= 0 && cartItems.filter(e => e.product_type === 'necklaces').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }
    if (cartItems.filter(e => e.product_type === 'necklaces').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'necklaces').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }

    if (cartItems.filter(e => e.product_type === 'bracelets').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'bracelets').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    } 
    if(cartItems.filter(e => e.product_type === 'bracelets').length > 0 && cartItems.filter(e => e.product_type === 'earrings').length <=0 && cartItems.filter(e => e.product_type === 'rings').length <=0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('ringProductType') && !upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }

    if(cartItems.filter(e => e.product_type === 'earrings').length <=0 && cartItems.filter(e => e.product_type === 'rings').length <=0 && cartItems.filter(e => e.product_type === 'necklaces').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('ringProductType') && !upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
